module.exports = __webpack_public_path__ + "assets/img/JID_v4-Final-JTC_RGB_hr.83f81a5f.jpg";